import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../../Styles/PageStyles";
import Images from "../../../Images";
import tw from "tailwind-styled-components";
import { PaginationLimit } from "../../../Config";
import { capitalizeFirstLetter, getCategoryIcon, getFoodCategoryLabel, getFoodUnitLabel, truncateText } from "../../../helpers";
import moment from "moment";
import { FaBuilding, FaFileInvoice, FaBox, FaMoneyBillWave, FaCalendarAlt, FaRegUser } from "react-icons/fa";
import { MdOutlineChevronRight } from "react-icons/md";
import Tooltip from "../../Tooltip";

const Table = ({ apiData, setShowPurchaseDetails, setSelectedPurchase }) => {
    const [data, setData] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
    const [currentPage, setCurrentPage] = useState(0);
    const [expandedPurchase, setExpandedPurchase] = useState(null);

    const toggleRow = (index) => {
        setSelectedRow(selectedRow === index ? null : index);
    };

    const onViewPurchase = (item) => {
        setSelectedPurchase(item);
        setShowPurchaseDetails(true);
    };
    useEffect(() => {
        if (apiData) {
            const tempData = apiData.map((item) => ({
                invoiceNo: item.invoiceNo,
                vendorName: getVendorInfo(item),
                itemDetails: getItemDetails(item),
                totalAmount: getTotalAmount(item),
                purchaseDate: (
                    <span className="text-gray-600 text-sm">
                        {/* {moment(item.purchaseDate).format("DD, MMM YY hh:mm A")} */}
                        {moment(item.purchaseDate).format("DD, MMM YY")}
                    </span>
                ),
                entries: item.entries || [],
                action: ActionBtns(item),
            }));
            setData(tempData);
        }
    }, [apiData]);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const ActionBtns = (item) => {
        const hasEntries = item.entries && item.entries.length > 0;

        return (
            <div className="flex items-center gap-3">
                <Tooltip label={hasEntries ? "Click to view details" : "No items to view"}>
                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            if (hasEntries) {
                                onViewPurchase(item);
                            }
                        }}
                        className={`px-4 ml-auto transition ${hasEntries
                            ? "text-gray-400 hover:text-gray-700 cursor-pointer"
                            : "text-gray-200 cursor-not-allowed"
                            }`}
                    >
                        <MdOutlineChevronRight size={22} />
                    </button>
                </Tooltip>
            </div>
        );
    };

    const getVendorInfo = (item) => {
        return (
            // <UserImageWrapper>
            //     <div className="flex flex-col min-w-0">
            //         <div className="flex items-center gap-2 group">
            //             <span className="font-medium text-gray-700 truncate">
            //                 {capitalizeFirstLetter(truncateText(item.vendorName, 28))}
            //             </span>
            //         </div>
            //         <span className="text-gray-400 text-xs flex items-center gap-1">
            //             {/* <FaFileInvoice className="text-xs" /> */}
            //             #{item.invoiceNo || 'N/A'}
            //         </span>
            //     </div>
            // </UserImageWrapper>
            <div className="flex flex-col gap-0.5 pl-2">
                {/* <div className="flex items-center gap-2 group"> */}
                <span className="text-sm font-medium text-gray-800 truncate">
                    {capitalizeFirstLetter(truncateText(item.vendorName, 28))}
                </span>
                {/* </div> */}
                <span className="text-gray-400 text-xs">#{item.invoiceNo || 'N/A'}</span>
            </div>
        );
    };

    // const getItemDetails = (item) => {
    //     const entries = item.entries || [];
    //     const count = entries.length;

    //     return (
    //         <button className="flex flex-col gap-1 cursor-pointer"
    //             onClick={(e) => {
    //                 e.stopPropagation();
    //                 onViewPurchase(item);

    //             }}>
    //             <span className="text-sm text-gray-600">
    //                 {count} item{count !== 1 ? 's' : ''}
    //             </span>

    //         </button>
    //     );
    // };

    const getItemDetails = (item) => {
        const entries = item.entries || [];
        const count = entries.length;

        return (
            <button
                type="button"
                className="group flex flex-col items-start"
                onClick={() => onViewPurchase(item)}
            >
                <span className="text-sm font-medium text-gray-700">
                    {count} Item{count !== 1 ? "s" : ""}
                </span>

                <span className="text-xs text-gray-400 group-hover:text-primary-color transition-colors">
                    View details
                </span>
            </button>
        );
    };

    const getTotalAmount = (item) => {
        return (
            <div className="flex flex-col">
                <span className="text-base font-semibold text-gray-800">
                    ₹{item.totalAmount || 0}
                </span>

                <span className="text-xs text-gray-400">
                    Purchase value
                </span>
            </div>
        );
    };

    const columns = React.useMemo(() => {
        if (isMobileView) {
            return [
                {
                    Header: "Vendor",
                    accessor: "vendorName",
                },
                {
                    Header: "Amount",
                    accessor: "totalAmount",
                },
            ];
        }
        return [
            {
                Header: "Vendor ",
                accessor: "vendorName",
            },
            {
                Header: "Items",
                accessor: "itemDetails",
            },
            {
                Header: "Amount",
                accessor: "totalAmount",
            },
            {
                Header: "Date",
                accessor: "purchaseDate",
            },
            {
                Header: "",
                accessor: "action",
            },
        ];
    }, [isMobileView, expandedPurchase]);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        pageOptions,
        page,
        state: { pageIndex },
        previousPage,
        nextPage,
        canPreviousPage,
        canNextPage,
    } = useTable(
        {
            data,
            columns,
            initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
        },
        useSortBy,
        usePagination
    );

    useEffect(() => {
        setCurrentPage(pageIndex);
    }, [pageIndex]);

    return (
        <>
            <CustomTable {...getTableProps()}>
                <Thead>
                    {headerGroups.map((headerGroup) => (
                        <Tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                    {column.render("Header")}
                                    <span>
                                        {column.isSorted ? (
                                            <img
                                                src={Images.Arrow}
                                                alt="down arrow"
                                                className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                                                    } w-1.5 inline-block ml-1.5`}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </span>
                                </Th>
                            ))}
                        </Tr>
                    ))}
                </Thead>
                <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
                    {page.map((row, rowIndex) => {
                        prepareRow(row);
                        return (
                            <React.Fragment key={rowIndex}>
                                <Tr {...row.getRowProps({ style: { height: "80px" } })} hasdata={(apiData?.length > 0).toString()}>
                                    {row.cells.map((cell, cellIndex) => {
                                        return (
                                            <Td
                                                {...cell.getCellProps()}
                                                onClick={() => {
                                                    if (
                                                        cellIndex === 0 ||
                                                        (cellIndex === 1 && window.innerWidth < 768)
                                                    ) {
                                                        toggleRow(rowIndex);
                                                    }
                                                }}
                                            >
                                                {cell.render("Cell")}
                                            </Td>
                                        );
                                    })}
                                </Tr>
                                {selectedRow === rowIndex && window.innerWidth < 768 && (
                                    <Tr>
                                        <Td colSpan={columns.length}>
                                            <ul className="flex flex-col gap-2">
                                                <li>
                                                    <strong>Vendor:</strong>{" "}
                                                    {data[rowIndex]?.vendorName?.props?.children?.[1]?.props?.children?.[0]?.props?.children || 'N/A'}
                                                </li>
                                                <li>
                                                    <strong>Invoice No:</strong>{" "}
                                                    {data[rowIndex]?.vendorName?.props?.children?.[1]?.props?.children?.[1]?.props?.children || 'N/A'}
                                                </li>
                                                <li>
                                                    <strong>Items:</strong>
                                                    <div className="mt-2">
                                                        {data[rowIndex]?.entries && data[rowIndex].entries.length > 0 ? (
                                                            data[rowIndex].entries.map((entry, idx) => (
                                                                <div key={idx} className="flex items-center justify-between py-1 border-b border-gray-100 last:border-0">
                                                                    <div className="flex items-center gap-2">
                                                                        {getCategoryIcon(entry.categoryId)}
                                                                        <span className="text-sm">{entry.itemName}</span>
                                                                    </div>
                                                                    <div className="flex items-center gap-3 text-xs text-gray-500">
                                                                        <span>Qty: {entry.quantity}</span>
                                                                        <span>{getFoodUnitLabel(entry.unitType)}</span>
                                                                        <span>₹{entry.price}</span>
                                                                        {/* <span className="font-medium">₹{entry.price * entry.quantity}</span> */}
                                                                    </div>
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <span className="text-gray-400 text-sm">No items</span>
                                                        )}
                                                    </div>
                                                </li>
                                                <li>
                                                    <strong>Total Amount:</strong>{" "}
                                                    {data[rowIndex]?.totalAmount?.props?.children || 0}
                                                </li>
                                                <li>
                                                    <strong>Purchase Date:</strong>{" "}
                                                    {data[rowIndex]?.purchaseDate}
                                                </li>
                                            </ul>
                                        </Td>
                                    </Tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                </Tbody>
            </CustomTable>
            {apiData?.length > 0 && (
                <PaginationWrapper>
                    <div className="px-2">
                        Page{" "}
                        <em>
                            {pageIndex + 1} of {pageOptions.length}
                        </em>
                    </div>
                    <div className="flex gap-1">
                        <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
                            <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75" />
                        </PrevBtn>
                        <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
                            <img
                                src={Images.Arrow}
                                alt="arrow"
                                className="w-2 rotate-180 opacity-75"
                            />
                        </NextBtn>
                    </div>
                </PaginationWrapper>
            )}
        </>
    );
};

const UserImageWrapper = tw.div`flex items-center gap-2`;
const IconWrapper = tw.div`w-8 h-8 flex items-center justify-center rounded-full bg-primary-color/10`;
const EntryItem = tw.div`flex flex-col sm:flex-row sm:items-center justify-between py-2 border-b border-gray-100 last:border-0 gap-1`;
const CustomTable = tw.table`w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
    props.hasdata === "true"
        ? "border-b"
        : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-1 text-sm md:p-2 text-left`;
const UserImage = tw.img`w-10 h-10 rounded-full `;

export default Table;